import React from 'react';

/**
 * Small labelled input with optional left icon.
 * Extracted from EmailMailboxSection (Vague 97.3 — split for maintainability).
 */
export default function EmailFormField({ icon: Icon, label, value, onChange, type = 'text', placeholder, testId, full }) {
  return (
    <div className={full ? 'sm:col-span-2' : ''}>
      <label className="text-[12.5px] font-semibold text-[#4A4B63] block mb-1.5">{label}</label>
      <div className="relative">
        {Icon && <Icon className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-[#8E8FA5]" />}
        <input
          type={type}
          value={value ?? ''}
          placeholder={placeholder}
          data-testid={testId}
          onChange={(e) => onChange(e.target.value)}
          className={`w-full h-10 ${Icon ? 'pl-8' : 'pl-3'} pr-3 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[13.5px] focus:bg-white focus:border-[#4F46E5] focus:ring-2 focus:ring-[#EDE8FF] outline-none`}
          autoComplete="new-password"
        />
      </div>
    </div>
  );
}
